// 商品类型列表
export const productList = [
  { label: '洗漱用品类', value: 1 },
  { label: '生活用品类', value: 2 },
  { label: '办公用品类', value: 3 },
  { label: '食品类', value: 4 },
  { label: '饮料类', value: 5 },
  { label: '电子产品类', value: 6 },
  { label: '大额奖励', value: 7 }
]

// 商品类型
export const productMap = {
  1: '洗漱用品类',
  2: '生活用品类',
  3: '办公用品类',
  4: '食品类',
  5: '饮料类',
  6: '电子产品类',
  7: '大额奖励'
}

// 商品状态列表
export const stateList = [
  { label: '上架', value: 1 },
  { label: '下架', value: 2 }
]

// 商品状态
export const stateMap = {
  1: '上架',
  2: '下架'
}

// 商品来源列表
export const sourceList = [
  { label: '系统商品库', value: 1 },
  { label: '手动录入', value: 2 }
]

// 核销状态列表
export const cancelStateList = [
  { label: '待核销', value: 1 },
  { label: '已核销', value: 2 },
  { label: '已取消', value: 3 }
]

// 核销状态
export const cancelStateMap = {
  1: '待核销',
  2: '已核销',
  3: '已取消'
}
